import React from 'react';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as SettingsActionCreators from '../../../actions/settings';

class EmailLinkDialog extends React.Component {
  /**
   * State
   * @type {Object}
   */
  state = {
    userInput: {
      emailAddress: '',
      password: '',
    },
  }


  /**
   * Handle change
   * @param  {Object} e
   * @return {undefined}
   */
  handleChange = (e) => {
    const userInput = this.state.userInput;

    userInput[e.target.name] = e.target.value;

    this.setState({
      userInput: {
        ...this.state.userInput,
        ...userInput,
      },
    });
  }


  /**
   * handle form submit
   * @return {undefined}
   */
  handleFormSubmit = (e) => {
    e.preventDefault();
    const userInput = this.state.userInput;

    if (!userInput) {
      return;
    }

    this.props.dispatch(SettingsActionCreators.linkEmailToAccount(userInput));
  }

  /**
   * Render
   * @return {JSX}
   */
  render() {
    const { emailAddress, password } = this.state.userInput;
    const { isLinkingEmail, message } = this.props;
    const isButtonDisabled = (!emailAddress || !password);

    return (
      <div>
        <h3 className="heading heading--2" style={{ color: '#000' }}>Link Email To Account</h3>
        <form onSubmit={this.handleFormSubmit}>
          <p>
            <label htmlFor="emailAddress">Email</label>
            <input id="emailAddress" className="form__control" type="email" name="emailAddress" onChange={this.handleChange} value={emailAddress} />
          </p>
          <p>
            <label htmlFor="password">Password</label>
            <input id="password" className="form__control" type="password" name="password" onChange={this.handleChange} value={password} />
          </p>
          { message ? <p dangerouslySetInnerHTML={{ __html: message }} /> : null }
          <div className="dialog__actions" style={{ marginTop: 24 }}>
            <button className="button button--primary" onClick={this.props.closeDialog}>Cancel</button>
            <button className="button button--primary" disabled={isButtonDisabled}>{ isLinkingEmail ? 'Saving...' : 'Link Email' }</button>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => (
  {
    isLinkingEmail: state.settings.isLinkingEmail,
    message: state.settings.emailMessage,
  }
);

export default withRouter(connect(mapStateToProps)(EmailLinkDialog));
